import React from "react";
import {useDispatch, useSelector} from "react-redux";
import BaseBooleanField from '../../../Base/ui/inputs/BooleanField'
import updateAssociationName from "../helpers/update_association_name";

const BooleanField = ({resource = 'affiliateMemberDetail', name, label, col, action, textDecorator}) => {
  const value = useSelector((state) => state[resource][name]);
  const dispatch = useDispatch();
  const fieldAction = action || useSelector((state) => state.ui.action);

  const dispatchChange = (name, value) => {
    dispatch({type: `UPDATE_${updateAssociationName(resource)}`, payload: {name, value}})
  }

  const handleChange = (option) => {
    const value = option === null ? null : option.value;
    dispatchChange(name, value);
  }

  return (
    <BaseBooleanField
      resource={resource}
      name={name}
      label={label}
      col={col}
      value={value}
      action={fieldAction}
      onChange={handleChange}
    />
  );
}

export default BooleanField;
